import 'infinite-scroll/dist/infinite-scroll.pkgd.min.js'; // https://github.com/metafizzy/infinite-scroll
import common from './common.js';

export default {
	init() {
		var $container = $('.listing--updates');

		$container.infiniteScroll({
			// options
			path: '/team-news/page/{{#}}',
			append: '.list-item--wrap',
			loadOnScroll: false,
			button: '.view-more-button',
		});

		// retrigger reveals
		$container.on('append.infiniteScroll', function () {
			common.itemReveal();
		});

		document.querySelector('.custom-select-wrapper').addEventListener('click', function () {
			this.querySelector('.custom-select').classList.toggle('open');
		});

		let select = document.getElementById('topics');
		let form = document.querySelector(".filters--posts");

		for (const option of document.querySelectorAll(".custom-option")) {
			option.addEventListener('click', function () {
				if (!this.classList.contains('selected')) {
					if (document.querySelector('.custom-option.selected')) {
						document.querySelector('.custom-option.selected').classList.remove('selected');
					}
					this.classList.add('selected');
					document.querySelector('.custom-select__trigger span').textContent = this.textContent;

					// trigger select on the actual <select>
					select.value = this.dataset.value;
					form.submit();
				}
			});
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/news-events.js